<template>
  <slot v-if="hasPermission" />
</template>

<script setup lang="ts">
import { computed } from "vue";

import Permissions, {
  type PermissionsProducts,
} from "shared/services/Permissions";
import { type PermissionKey } from "shared/types/permissions";

interface HasPermissionProps {
  check?: (permissions: Permissions) => boolean;
  permission?: PermissionKey;
  product?: PermissionsProducts;
}

const props = withDefaults(defineProps<HasPermissionProps>(), {
  product: "traditional",
  check: undefined,
  permission: undefined,
});

const permissions = computed(() => new Permissions());

const hasPermission = computed(() => {
  if (props.check) return props.check(permissions.value);

  if (!props.permission) return false;

  return permissions.value.has(props.permission, props.product);
});
</script>
